(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["habit-shop-filter-row"] && !Shopify.designMode) return;
  try {
    
  const PLACEHOLDER = '__n__';
  let activeGroup = 'all';

  if (window.Shopify && window.Shopify.designMode) {
    document.documentElement.classList.add('habit-filter-design-mode');
  }

  function groupWrapper(node) {
    return node.closest('.shopify-section') || node;
  }

  function isHidden(wrap) {
    return wrap.hasAttribute('hidden') || wrap.style.display === 'none';
  }

  function countVisibleCards() {
    let count = 0;
    document.querySelectorAll('[data-class-group]').forEach((node) => {
      const wrap = groupWrapper(node);
      if (isHidden(wrap)) return;
      count += wrap.querySelectorAll('[data-class-card]').length;
    });
    return count;
  }

  function formatCount(bar, count) {
    const template = count === 1 ? bar.getAttribute('data-count-one') : bar.getAttribute('data-count-other');
    if (!template) return '';
    return template.split(PLACEHOLDER).join(String(count));
  }

  function syncBars() {
    document.querySelectorAll('[data-habit-filter]').forEach((bar) => {
      bar.querySelectorAll('[data-filter]').forEach((button) => {
        const on = button.getAttribute('data-filter') === activeGroup;
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      const countEl = bar.querySelector('[data-habit-filter-count]');
      if (countEl) countEl.textContent = formatCount(bar, countVisibleCards());
    });
  }

  function applyFilter(group) {
    activeGroup = group || 'all';
    if (!document.querySelector('[data-habit-filter]')) {
      activeGroup = 'all';
    }

    document.querySelectorAll('[data-class-group]').forEach((node) => {
      const wrap = groupWrapper(node);
      const match = activeGroup === 'all' || node.getAttribute('data-class-group') === activeGroup;
      if (match) {
        wrap.removeAttribute('hidden');
        wrap.style.display = '';
      } else {
        wrap.setAttribute('hidden', '');
        wrap.style.display = 'none';
      }
    });

    syncBars();
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-habit-filter] [data-filter]');
    if (!button) return;
    event.preventDefault();
    applyFilter(button.getAttribute('data-filter'));
  });

  document.addEventListener('shopify:section:load', () => {
    applyFilter(activeGroup);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => applyFilter(activeGroup));
  } else {
    applyFilter(activeGroup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
